import React from "react";

import ResultPublishs from "../../components/StaffTabs/StaffAssignment/ResultPublishs";

const AdminResult = () => {
  return (
    <div>
      <ResultPublishs/>
    </div>
  );
};

export default AdminResult;
